<template>
  <v-container class="fill-height tw-overflow-auto" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="5" sm="12">
        <v-card class="mx-auto">
          <v-container>
            <v-card-title>
              <v-layout align-center justify-center>
                <v-img contain max-width="200" src="@/assets/securating_logo.png" />
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-layout :style="message_style" align-center justify-center>
                {{ message }}
              </v-layout>
              <br />
              <v-layout align-center justify-center>
                <a href="/">{{ $t("messages.buttonGoBackOffice") }}</a>
              </v-layout>
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "MessageBox",
  data: () => ({
    message: "",
    message_style: "font-size:130%;",
  }),
  mounted() {
    if (this.$route.query.message) {
      this.message = this.$t(this.$route.query.message)
    } else {
      this.message = this.$t("messages.defaultMessage")
    }
    if (this.$route.query.warning) {
      this.message_style += "color:red;"
    }
  },
}
</script>
